module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "detail-card"
  }, [_c('h5', [_vm._v("Transfer Payment Invoice")]), _vm._v(" "), (_vm.set_select_mode > 0) ? _c('a', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.set_select_mode = 0;
        _vm.setMenuTabView('', '')
      }
    }
  }, [_vm._v(" Back")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), (_vm.menu_tab_view.selectItemsForInvoice) ? _c('div', [((_vm.set_select_mode == 1) && (Object.keys(_vm.data_user).length > 0)) ? _c('div', [_c('h3', [_vm._v("Invoice For: " + _vm._s(_vm.data_user.name))])]) : _vm._e(), _vm._v(" "), (_vm.menu_tab_inner_view.previewSelectedItemsForInvoice) ? _c('div', [_c('h3', [_vm._v("Confirm selected Items")]), _vm._v(" "), _c('div', [(_vm.invoice_added_items && (Object.keys(_vm.invoice_added_items).length > 0)) ? _c('div', [_vm._l((_vm.invoice_added_items), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-xs-12 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em",
        "text-align": "left"
      }
    }, [_c('div', {
      staticClass: "col-xs-4 card-col-img"
    }, [(product.product_data.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_data.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-8 card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "left"
      }
    }, [_vm._v(_vm._s(product.product_data.product_name)), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_item_price_f))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Quantity: "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (product.order_item_order_quantity),
        expression: "product.order_item_order_quantity"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (product.order_item_order_quantity)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          product.order_item_order_quantity = $event.target.value
        }
      }
    })])])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  }), _vm._v(" "), _c('div', [_c('a', {
    staticClass: "btn sp-button-02",
    on: {
      "click": _vm.generatePaymentOrders
    }
  }, [_vm._v("Generate Invoice")])])], 2) : _vm._e()])]) : _c('div', [_c('p', [_vm._v("Add items to Invoice")]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.data_loading.products) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(1)]) : _c('div', [(_vm.products && (Object.keys(_vm.products).length > 0)) ? _c('div', _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "card col-xs-4 card-col-2",
      staticStyle: {
        "margin-bottom": "2.2em",
        "min-height": "15em",
        "max-height": "15em"
      }
    }, [_c('a', {
      staticStyle: {
        "text-decoration": "none",
        "color": "inherit"
      },
      on: {
        "click": function($event) {
          _vm.setProduct(product)
        }
      }
    }, [_c('div', {
      staticClass: "card-col-img"
    }, [(product.product_images[0]) ? _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": product.product_images[0].product_image
      }
    }) : _c('img', {
      staticClass: "img-responsive",
      staticStyle: {
        "max-height": "8em"
      },
      attrs: {
        "src": "/static/assets/images/dummy-image.png"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "card-col-details",
      staticStyle: {
        "display": "block",
        "padding": "3px"
      }
    }, [_c('p', {
      staticClass: "prd-name",
      staticStyle: {
        "font-size": "13px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(product.product_name)), _c('br'), _vm._v(" "), (product.product_items[0]) ? _c('span', {
      staticClass: "sp-app-default-color",
      staticStyle: {
        "font-weight": "bolder"
      }
    }, [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price_f))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "add-pad"
    }, [(_vm.isItemInList(product.product_items[0])) ? _c('div', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": true
      },
      on: {
        "click": function($event) {
          _vm.removeItemsFromInvoice(product.product_items[0])
        }
      }
    }), _vm._v(" Added\n                                ")]) : _c('div', [(!(_vm.isItemInList(product.product_items[0]))) ? _c('input', {
      attrs: {
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addItemsToInvoice(product.product_items[0], product)
        }
      }
    }) : _vm._e(), _vm._v(" Add\n                                ")])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "clear": "both"
      }
    })])
  })) : _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("No products yet")]), _vm._v(" "), _c('a', {
    staticClass: "btn sp-vutton-02",
    attrs: {
      "href": "/account/business/newproduct"
    }
  }, [_vm._v("Add Products")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), ((Object.keys(_vm.invoice_added_items).length > 0)) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "bottom": "1em",
      "background-color": "#ff0000",
      "height": "2em"
    }
  }, [_c('a', {
    staticClass: "btn sp-button-02",
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('previewSelectedItemsForInvoice')
      }
    }
  }, [_vm._v("Add (" + _vm._s(Object.keys(_vm.invoice_added_items).length) + ") Item(s) to Invoice")])]) : _vm._e()])]) : _c('div', [_c('p', [_vm._v("Generate and send Transfer Invoice to a customer or more than one customer. Customers who \n                click on the link can quickly make transfers directly to your bank account for products you \n                added to the invoice.")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Generate invoice:")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_select_mode),
      expression: "set_select_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.set_select_mode, "1")
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabInnerView('one_customer')
      },
      "__c": function($event) {
        _vm.set_select_mode = "1"
      }
    }
  }), _vm._v(" For One Customer"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.set_select_mode),
      expression: "set_select_mode"
    }],
    attrs: {
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.set_select_mode, "2")
    },
    on: {
      "click": function($event) {
        _vm.setMenuTabView('', 'selectItemsForInvoice')
      },
      "__c": function($event) {
        _vm.set_select_mode = "2"
      }
    }
  }), _vm._v(" General - Anyone can pay"), _c('br')]), _vm._v(" "), (_vm.menu_tab_inner_view.one_customer) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Customer's eShop username or phone number or email")]), _vm._v(" "), (_vm.data_error_message != '') ? _c('p', [_vm._v(_vm._s(_vm.data_error_message))]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customer.custormer_name),
      expression: "customer.custormer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.customer.custormer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customer.custormer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn sp-button-02 sp-button-sm",
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.getUsersDetails(_vm.customer.custormer_name, _vm.customer, 'get_customer_details_for_invoice_request')
      }
    }
  }, [_vm._v("Enter")])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "loading-sm"
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v("loading products...")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29b707c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Account/Sellpoint/Components/GenerateTransferPayment.vue
// module id = 562
// module chunks = 0